import { Grid } from '@mui/material';
import { SolicitudCoberturaProvider } from '../components/SolicitudCoberturaIniciadoAutorizado/context';
import { SolicitudCoberturaIniciadoAutorizado } from '../components/SolicitudCoberturaIniciadoAutorizado/views';
import { SolicitudCoberturaTramitesPorAuditor } from '../components/SolicitudCoberturaTramitesPorAuditor/views';
import { SolicitudCoberturaTramitesPorDelegacion } from '../components/SolicitudCoberturaTramitesPorDelegacion/views';

export const AmbulatorioMain = () => {
  return (
    <Grid container spacing={2}>
      <Grid item container spacing={2} xs={12} md={6}>
        <SolicitudCoberturaProvider>
          <SolicitudCoberturaIniciadoAutorizado />
        </SolicitudCoberturaProvider>
      </Grid>

      <Grid item container spacing={2} xs={12} md={6}>
        {/* <Grid item xs={12} md={6}>
          <SolicitudCoberturaTramitesPorAuditor />
        </Grid> */}
        {/* <Grid item xs={12} md={6}> */}
          <SolicitudCoberturaTramitesPorDelegacion />
        {/* </Grid> */}
      </Grid>
    </Grid>
  );
};
